import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { getPreference } from '../../../../utils/util';

import { requestViewAllCurrencyCodes } from '../../../../api/currency-code/currency-code.actions';
import { requestSavePreference } from '../../../../api/preference/preference.actions';

import Modal from '../../modal/Modal';
import CurrencyDropdown from '../../inputs/dropdown/currency-dropdown/CurrencyDropdown';
import Button from '../../button/Button';

import './currency-modal.scss';

const CurrencyModal = ({ show, onClose }) => {
  const currencyCodes = useSelector((state) => state.currency.currencyCodes);

  const [selectedCurrency, setSelectedCurrency] = useState('USD');

  const dispatch = useDispatch();

  useEffect(() => {
    const preference = getPreference('currency');
    if (preference) {
      setSelectedCurrency(preference);
    }
  }, [show]);

  useEffect(() => {
    dispatch(requestViewAllCurrencyCodes());
  }, [dispatch]);

  const handleSaveClick = () => {
    dispatch(
      requestSavePreference({
        preference: {
          name: 'currency',
          value: selectedCurrency,
        },
        onSuccess: () => onClose(selectedCurrency),
      })
    );
  };

  return (
    <Modal show={show} onClose={() => onClose()}>
      <div className="currency-modal">
        <div className="currency-modal__header">
          <p className="currency-modal__title">Change Currency</p>
        </div>

        <CurrencyDropdown value={selectedCurrency} onChange={setSelectedCurrency} options={currencyCodes} />

        <div className="currency-modal__buttons">
          <Button className="currency-modal__button" onClick={() => onClose()} secondary>
            Cancel
          </Button>
          <Button className="currency-modal__button" onClick={handleSaveClick}>
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

CurrencyModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CurrencyModal;
